import { ChangeDetectorRef, Component, Input, Output, EventEmitter, OnInit, ViewChild, AfterViewInit, OnDestroy } from "@angular/core";
import { FormBuilder, FormGroup, ReactiveFormsModule, FormsModule } from "@angular/forms";
import { Subscription } from "rxjs";
import { MatPaginator } from "@angular/material/paginator";
import { MatTableDataSource, MatTableModule } from "@angular/material/table";
import { ReprocessingTableService } from "../../../../service/table/reprocessing-table.service";
import { TableResponse } from "../../../../_model/table-response/table-response";

import { ClientStateService } from "../../../../components/navbar/client-state.service";
import { Constants } from "../../../../_model/constants";
import { SelectionModel } from "@angular/cdk/collections";
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

import { TableData } from "../../../../_model/table-response/table-data";
import { ReprocessingRulesDialogComponent } from "../../../../components/reprocessing-rules-dialog/reprocessing-rules-dialog.component";
import { ReprocessWoDTO } from "../../../../_model/ReprocessWorkOrderDTO";
import { WarningDialogComponent } from "../../../../components/warning-dialog/warning-dialog.component";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatIconModule } from "@angular/material/icon";
import { ReprocessingMultipleInputFilterComponent } from "../../../reprocessing-multiple-input-filter/reprocessing-multiple-input-filter/reprocessing-multiple-input-filter.component";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatTooltipModule } from "@angular/material/tooltip";
import { CommonModule } from "@angular/common";
import { MatButtonModule } from "@angular/material/button";
import { MatSelectChange, MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatListModule } from '@angular/material/list';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatRadioModule } from '@angular/material/radio';
import { MatChipsModule } from '@angular/material/chips';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatCardModule } from '@angular/material/card';
export interface checkedDataSource1 {
  selected: boolean,
  workOrderNumber: string;
  createdDate: string;
  type: string;
  storeId: string;
  statusBeforeProcessing: string;
  scheduledStart: string;
  dueDate: string;
  reprocessed: boolean;
  reprocessedDate: string;
  statusAfterProcessing: string;
  reprocessingCount: number;

}


@Component({
  selector: "app-reprocessing-table",
  templateUrl: "./reprocessing-table.component.html",
  standalone: true,
  imports: [MatPaginator, MatCheckboxModule, MatIconModule, ReprocessingMultipleInputFilterComponent, 
    MatProgressSpinnerModule, MatTooltipModule, MatTableModule, CommonModule, FormsModule, 
    ReactiveFormsModule, MatButtonModule, MatSelectModule, MatDatepickerModule, MatNativeDateModule,
    MatAutocompleteModule, MatDialogModule, MatTabsModule, MatToolbarModule, MatListModule,
    MatSidenavModule, MatExpansionModule, MatSnackBarModule, MatGridListModule, MatRadioModule, MatChipsModule, MatFormFieldModule, MatInputModule, MatCardModule],
  styleUrls: ["./reprocessing-table.component.scss"],
})
export class ReprocessingTableComponent implements OnInit, OnDestroy, AfterViewInit{
  @Input() reprocessingTableService!: ReprocessingTableService;
  @Output() callFilter = new EventEmitter<string>();
  btnDisable!: boolean;
  reprocessedFlag = false;
  removeRowFlag = false;
  isRefresh = false;
  isHint = false;
  hideReprocessedTable = false;
  constructor(public dialog: MatDialog, private clientStateService: ClientStateService, private changeDetectorRefs: ChangeDetectorRef) { }


  @ViewChild('paginator', { static: true }) paginator!: MatPaginator;
  @ViewChild('checkedpaginator', { static: true }) checkedpaginator!: MatPaginator;

  checkedDataSource!: MatTableDataSource<TableResponse>;
  public client!: TableResponse;
  public clients!: TableResponse[];
  readonly table1Selections = [];
  readonly table2Selections = [];
  checkedData = [];
  displayedColumns: string[] = ['selected', 'workOrderNumber', 'createdDate', 'type', 'storeId', 'statusBeforeProcessing', 'scheduledStart', 'dueDate', 'reprocessed', 'reprocessedDate', 'statusAfterProcessing', 'reprocessingCount'];
  selection = new SelectionModel<TableResponse>(true, []);
  removedRowUpdatedTable: MatTableDataSource<checkedDataSource1> = new MatTableDataSource<checkedDataSource1>([]);
  table3: MatTableDataSource<TableResponse> = new MatTableDataSource<TableResponse>([]); 

  checkedSelection = new SelectionModel<TableResponse>(true, []);
  selectedFilters!: FormGroup<any> | null;
  isLoadingData = false;
  clientSubscription!: Subscription;
  paginatorSubscription!: Subscription;
  checkedPaginatorSubscription!: Subscription;
  showReportMessage = true;
  pageData = { pageIndex: 0, pageSize: 5 };
  isLoadingResults = true;
  loading = false;
  length!: number;
  table2?: TableResponse;
  tableDisplayedColumns!: string[];
  ELEMENT_DATA: Element[] = [];
  ngOnInit() {
    this.selectedFilters = null;
    this.isLoadingData = true;
    this.hideReprocessedTable = false;
    this.paginator.pageSize = 100;
    this.initializeTable(0, 100);
    this.clientSubscription =
      this.clientStateService.clientStateChanged$.subscribe(() => {
        this.paginator.firstPage();
        this.paginator.pageSize = 100;
        this.selectedFilters = null;
        this.initializeTable(0, 100);
      });
    this.paginatorSubscription = this.paginator.page.subscribe((event) => {
      this.initializeTable(event.pageIndex, event.pageSize);
    });
  }

  ngAfterViewInit() {
    if (this.paginator) {
      this.paginatorSubscription = this.paginator.page.subscribe(event => {
        this.initializeTable(event.pageIndex, event.pageSize);
      });
    }
  }

  openDialog() {
    const dialogRef = this.dialog.open(ReprocessingRulesDialogComponent);
    dialogRef.afterClosed().subscribe(result => {
      // console.log(`Dialog result: ${result}`);
    });
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.table2?.data.tableRows.length || 0;
    return numSelected === numRows;
  }

  isAllCheckedSelected() {
    const numSelected = this.checkedSelection.selected.length;
    const numRows = this.checkedDataSource.data.length;
    return numSelected === numRows;
  }

  isSomeSelected() {
    return this.selection.selected.length > 0;
  }

  masterToggle(ref: any) {
    if(this.isSomeSelected()){
      this.selection.clear();
      ref.checked=false;
      return;
    }
    else if (this.isAllSelected()) {
      this.selection.clear();
      return;
    }
    if (this.table2?.data) {
      this.selection.select(...this.table2.data.tableRows);
    }
  }

  masterCheckedToggle() {
    if (this.isAllCheckedSelected()) {
      this.checkedSelection.clear();
      return;
    }
    // this.checkedSelection.select(...this.checkedDataSource.data.tableRows)
  }
  customTB(item: any, index: number) {
    return `${item}-${index}`;
  }
  ngOnDestroy(): void {
    this.clientSubscription.unsubscribe();
  }


  fetchData(data: any) {
    // console.log(data);
  }
  onSelectedFilter(selectedFilter: FormGroup) {
    if (
      (selectedFilter.value &&
        selectedFilter.value.tableFilter &&
        selectedFilter.value.value) ||
      (selectedFilter &&
        typeof selectedFilter.value.multipleFilterarray != "undefined" &&
        selectedFilter.value.multipleFilterarray != null &&
        selectedFilter.value.multipleFilterarray.length != null &&
        selectedFilter.value.multipleFilterarray.length > 0)
    ) {
      this.selectedFilters = selectedFilter;
      this.selection.clear();
      this.showReportMessage = false;
    } else {
      this.selectedFilters = null;
      this.showReportMessage = true;
    }
    this.paginator.pageSize = 100;
    this.paginator.firstPage();
    this.initializeTable(0, 100);
  }


  public initializeTable(page: number, size: number) {
    this.isLoadingData = true;
    this.loading = true;
    this.isLoadingResults = false;
    this.hideReprocessedTable = false;
    this.isRefresh = false;
    this.reprocessedFlag = false;
    this.removeRowFlag = false;
    this.selection.clear();
    const filterFormGroup = this.selectedFilters || new FormGroup({});
    this.reprocessingTableService.getTableData(filterFormGroup, page, size).subscribe(
      (result) => {
        if (result.data.tablePagination && result.data.tablePagination.last) {
          this.length = result.data.tableRows.length;
        }
        else if (!result.data.tablePagination) {
          this.length = 0;
        }
        else {
          this.length =
            this.paginator.pageSize * (this.paginator.pageIndex + 1) + 1;
        }
        this.table2 = result;
        this.table3.data = result.data.tableRows;
        this.tableDisplayedColumns = result.data.tableDefinitions.map(
          (c) => c.columnDef
        );
        this.isLoadingResults = false;
        this.loading = false;
      },
      () => (this.isLoadingResults = false, this.loading = false)
    );
  }

  onRefresh() {
    this.hideReprocessedTable = true;
    this.isRefresh = true;
    this.reprocessedFlag = false;
    this.selection.clear();
    // this.selectedFilters = null;
    if (this.paginator.hasPreviousPage()) {
      this.paginator.firstPage();
    }
    else if (this.selectedFilters == null) {
      this.initializeTable(0, this.paginator.pageSize);
    }
    else if (this.selectedFilters !== null) {
      this.callFilter.emit();
    }
  }


  openMsg() {
    const dialogRef = this.dialog.open(WarningDialogComponent);
    dialogRef.afterClosed().subscribe(result => {
      // console.log(`Dialog result: ${result}`);
    });
  }



  // <Dynalic reprocess function>
  onReprocess() {
    this.isLoadingData = true;
    this.isLoadingResults = true;
    this.isHint = true;
    this.reprocessedFlag = true;
    this.isRefresh = false;
    this.removeRowFlag = true;
    if (this.reprocessedFlag == true) {
      let tableRow: TableResponse;
      this.reprocessedFlag = false;
      this.isRefresh = false;
      this.removeRowFlag = false;
      if (this.selection.selected.length > 100) {
        this.reprocessedFlag = false;
        this.isLoadingResults = false;
        this.openMsg();
        this.selection.clear();

      }
      else {
        this.reprocessingTableService.reprocess(this.selection.selected, 0, this.pageData.pageIndex, this.pageData.pageSize).subscribe((client) => {
          this.reprocessedFlag = true;
          this.removeRowFlag = true;
          //  Required for paginator //
          this.clients = client.data.tableRows;
          this.checkedDataSource = new MatTableDataSource(this.clients);
          setTimeout(() => {
            this.checkedDataSource.paginator = this.checkedpaginator;
          })
          // this.length = client.data.tableRows.length;
          // this.checkedDataSource = result;
          // this.tableDisplayedColumns = this.checkedDataSource.data.tableDefinitions.map(
          //   (c) => c.columnDef
          // );

          for (let re of this.checkedDataSource.data) {
            this.changeDetectorRefs.detectChanges();
            let store_Id = (re as any)["storeId"];
            for (let d of this.checkedDataSource.data) {
              if ((d as any)["reprocessed"] == true) {
                (d as any)["isReprocessed"] = "Yes";
              }
              else {
                (d as any)["isReprocessed"] = "No";
              }
            }
          }
          this.isLoadingResults = false;
          this.btnDisable = true;
        });
      }
    }

    this.isLoadingData = false;
    this.reprocessedFlag = false;

  }


}
